<div class="generate-resources-container" [class.mini-mode]="miniMode">
    <!-- Fixed Header Section -->
    <div class="fixed-header" [class.mini-mode]="miniMode">
        <div class="content-wrapper">
            <!-- Row 1: Media Type Selector + Usage Stats -->
            <div class="selectors-row">
                <div class="media-type-selector">
                    <mat-icon class="selector-icon">perm_media</mat-icon>
                    <span class="selector-label">{{ 'ai.selectMediaType' | transloco }}</span>
                    <mat-radio-group (change)="onMediaTypeSelection($event)" [(ngModel)]="selectedMediaType"
                                     aria-label="Media type" class="radio-group">
                        <mat-radio-button value="image">{{ 'ai.image' | transloco }}</mat-radio-button>
                        <mat-radio-button value="video">{{ 'ai.video' | transloco }}</mat-radio-button>
                    </mat-radio-group>
                </div>

                <!-- Usage stats in top row for non-miniMode -->
                <div *ngIf="!miniMode" class="top-usage-stats-container">
                    <!-- Usage stats for photos -->
                    <div *ngIf="selectedMediaType === 'image'" class="top-usage-stats">
                        <div class="usage-header-top">
                            <mat-icon class="stats-icon">analytics</mat-icon>
                            <span class="stats-title">{{ 'ai.usage' | transloco }}</span>
                        </div>
                        <div class="remaining-highlight">
                            {{ photoUsage.remaining }}
                            <span class="remaining-label">{{ 'ai.left' | transloco }}</span>
                        </div>
                        <div class="usage-stat-top">
                            <span class="stat-label">{{ 'ai.used' | transloco }}</span>
                            <span class="stat-value">{{ photoUsage.count }}</span>
                        </div>
                        <div class="usage-stat-top">
                            <span class="stat-label">{{ 'ai.daily limit' | transloco }}</span>
                            <span class="stat-value">{{ photoUsage.max_calls }}</span>
                        </div>
                    </div>

                    <!-- Usage stats for videos -->
                    <div *ngIf="selectedMediaType === 'video'" class="top-usage-stats">
                        <div class="usage-header-top">
                            <mat-icon class="stats-icon">analytics</mat-icon>
                            <span class="stats-title">{{ 'ai.usage' | transloco }}</span>
                        </div>
                        <div class="remaining-highlight">
                            {{ videoUsage.remaining }}
                            <span class="remaining-label">{{ 'ai.left' | transloco }}</span>
                        </div>
                        <div class="usage-stat-top">
                            <span class="stat-label">{{ 'ai.used' | transloco }}</span>
                            <span class="stat-value">{{ videoUsage.count }}</span>
                        </div>
                        <div class="usage-stat-top">
                            <span class="stat-label">{{ 'ai.daily limit' | transloco }}</span>
                            <span class="stat-value">{{ videoUsage.max_calls }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Row 2: Search Input + Button -->
            <div class="search-row">
                <div class="search-container">
                    <mat-form-field class="search-field" appearance="outline">
                        <mat-label>
                            <mat-icon class="label-icon">search</mat-icon>
                            {{ selectedMediaType === 'image' ? ('ai.searchPhotos' | transloco) : ('ai.searchVideos' | transloco) }}
                        </mat-label>
                        <input matInput
                               [(ngModel)]="searchQuery"
                               (keyup.enter)="searchResources()"
                               class="search-input">
                        <button mat-icon-button matSuffix aria-label="Clear" (click)="searchQuery = ''; clearResults()" class="clear-btn">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </div>

                <div class="actions-sidebar">
                    <button
                            class="search-button"
                            mat-flat-button
                            color="primary"
                            [disabled]="searchQuery.length < 3 || loading"
                            (click)="searchResources()">
                        <mat-icon *ngIf="!loading">search</mat-icon>
                        <span *ngIf="!loading">{{ 'general.search' | transloco }}</span>
                        <app-loading *ngIf="loading" [size]="'20px'"></app-loading>
                    </button>
                </div>
            </div>

            <!-- MiniMode usage stats for photos - compact version at top -->
            <div *ngIf="miniMode && selectedMediaType === 'image'" class="mini-mode-usage-stats">
                <div class="mini-usage-header">
                    <mat-icon class="mini-usage-icon">analytics</mat-icon>
                    <span class="mini-usage-title">{{ 'ai.usage' | transloco }}</span>
                </div>
                <div class="mini-usage-content">
                    <div class="mini-usage-stat">
                        <span class="mini-stat-label">{{ 'ai.remaining' | transloco }}</span>
                        <span class="mini-stat-value">{{ photoUsage.remaining }}</span>
                    </div>
                    <div class="mini-usage-stat">
                        <span class="mini-stat-label">{{ 'ai.used' | transloco }}</span>
                        <span class="mini-stat-value">{{ photoUsage.count }}</span>
                    </div>
                    <div class="mini-usage-stat">
                        <span class="mini-stat-label">{{ 'ai.daily limit' | transloco }}</span>
                        <span class="mini-stat-value">{{ photoUsage.max_calls }}</span>
                    </div>
                </div>
            </div>

            <!-- MiniMode usage stats for videos - compact version at top -->
            <div *ngIf="miniMode && selectedMediaType === 'video'" class="mini-mode-usage-stats">
                <div class="mini-usage-header">
                    <mat-icon class="mini-usage-icon">analytics</mat-icon>
                    <span class="mini-usage-title">{{ 'ai.usage' | transloco }}</span>
                </div>
                <div class="mini-usage-content">
                    <div class="mini-usage-stat">
                        <span class="mini-stat-label">{{ 'ai.remaining' | transloco }}</span>
                        <span class="mini-stat-value">{{ videoUsage.remaining }}</span>
                    </div>
                    <div class="mini-usage-stat">
                        <span class="mini-stat-label">{{ 'ai.used' | transloco }}</span>
                        <span class="mini-stat-value">{{ videoUsage.count }}</span>
                    </div>
                    <div class="mini-usage-stat">
                        <span class="mini-stat-label">{{ 'ai.daily limit' | transloco }}</span>
                        <span class="mini-stat-value">{{ videoUsage.max_calls }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Scrollable Content Section -->
    <div class="scrollable-content" [class.mini-mode]="miniMode">
        <!-- Loading Section -->
        <div *ngIf="loading" class="loading-section">
            <ngx-skeleton-loader
                    animation="progress-dark"
                    class="preview-loader"
                    [theme]="{height: '200px', width: '300px', borderRadius: '12px', 'background-color': 'var(--background-color1)'}">
            </ngx-skeleton-loader>
            <div class="loading-text-primary">
                {{ 'ai.searching' | transloco }}...
            </div>
        </div>

        <!-- Photos Grid -->
        <div *ngIf="selectedMediaType === 'image' && photos.length > 0 && !loading" class="results-grid">
        <div *ngFor="let photo of photos; trackBy: trackByPhotoId; let i = index"
             class="resource-card fade-in-item"
             [style.animation-delay]="(i * 20) + 'ms'">
            <div class="thumbnail-wrapper">
                <img [src]="photo.src.medium" [alt]="photo.alt" loading="lazy" class="thumbnail-image">
                <div class="image-overlay">
                    <button mat-fab color="primary" class="download-fab"
                            [matTooltip]="'general.downloadToResources' | transloco"
                            [disabled]="photo.downloading"
                            (click)="downloadPhoto(photo)">
                        <mat-icon *ngIf="!photo.downloading">download</mat-icon>
                        <app-loading *ngIf="photo.downloading" [size]="'20px'"></app-loading>
                    </button>
                </div>
            </div>
            <div class="card-info">
                <div class="card-title">{{ photo.alt || 'Photo by ' + photo.photographer }}</div>
                <div class="card-meta">
                    <span class="meta-item">
                        <mat-icon class="meta-icon">person</mat-icon>
                        {{ photo.photographer }}
                    </span>
                    <span class="meta-item">
                        <mat-icon class="meta-icon">aspect_ratio</mat-icon>
                        {{ photo.width }} x {{ photo.height }}
                    </span>
                </div>
            </div>
            </div>
        </div>

        <!-- Load More Photos Button -->
        <div *ngIf="selectedMediaType === 'image' && photos.length > 0 && hasMoreResults && !loading" class="load-more-container">
            <button mat-raised-button color="accent" class="load-more-button"
                    [disabled]="loadingMore"
                    (click)="loadMoreResults()">
                <div class="button-inner">
                    <div class="button-icon-wrapper">
                        <mat-icon *ngIf="!loadingMore" class="load-icon">autorenew</mat-icon>
                        <app-loading *ngIf="loadingMore" [size]="'24px'"></app-loading>
                    </div>
                    <div class="button-text-wrapper">
                        <span class="button-label">{{ loadingMore ? ('ai.loading' | transloco) : ('general.loadMore' | transloco) }}</span>
                        <span class="button-count">{{ photos.length }} / {{ totalResults }}</span>
                    </div>
                </div>
            </button>
        </div>

        <!-- Videos Grid -->
        <div *ngIf="selectedMediaType === 'video' && videos.length > 0 && !loading" class="results-grid">
        <div *ngFor="let video of videos; trackBy: trackByVideoId; let i = index"
             class="resource-card fade-in-item"
             [style.animation-delay]="(i * 20) + 'ms'">
            <div class="thumbnail-wrapper">
                <img [src]="video.image" [alt]="'Video by ' + video.user.name" loading="lazy" class="thumbnail-image">
                <div class="video-duration-badge">
                    <mat-icon class="duration-icon">play_circle_outline</mat-icon>
                    {{ video.duration }}s
                </div>
                <div class="video-action-bar">
                    <button mat-icon-button class="action-btn play-btn" (click)="previewVideo(video)"
                            [matTooltip]="'ai.preview' | transloco">
                        <mat-icon>play_circle</mat-icon>
                    </button>
                    <button mat-icon-button class="action-btn download-btn"
                            [matTooltip]="'general.downloadToResources' | transloco"
                            [disabled]="video.downloading"
                            (click)="downloadVideo(video)">
                        <mat-icon *ngIf="!video.downloading">download</mat-icon>
                        <app-loading *ngIf="video.downloading" [size]="'20px'"></app-loading>
                    </button>
                </div>
            </div>
            <div class="card-info">
                <div class="card-title">{{ 'ai.video' | transloco }} {{ 'general.by' | transloco }} {{ video.user.name }}</div>
                <div class="card-meta">
                    <span class="meta-item">
                        <mat-icon class="meta-icon">person</mat-icon>
                        {{ video.user.name }}
                    </span>
                    <span class="meta-item">
                        <mat-icon class="meta-icon">aspect_ratio</mat-icon>
                        {{ video.width }} x {{ video.height }}
                    </span>
                </div>
            </div>
            </div>
        </div>

        <!-- Load More Videos Button -->
        <div *ngIf="selectedMediaType === 'video' && videos.length > 0 && hasMoreResults && !loading" class="load-more-container">
            <button mat-raised-button color="accent" class="load-more-button"
                    [disabled]="loadingMore"
                    (click)="loadMoreResults()">
                <div class="button-inner">
                    <div class="button-icon-wrapper">
                        <mat-icon *ngIf="!loadingMore" class="load-icon">autorenew</mat-icon>
                        <app-loading *ngIf="loadingMore" [size]="'24px'"></app-loading>
                    </div>
                    <div class="button-text-wrapper">
                        <span class="button-label">{{ loadingMore ? ('ai.loading' | transloco) : ('general.loadMore' | transloco) }}</span>
                        <span class="button-count">{{ videos.length }} / {{ totalResults }}</span>
                    </div>
                </div>
            </button>
        </div>

        <!-- Empty State -->
        <div *ngIf="!loading && photos.length === 0 && videos.length === 0 && searchQuery.length > 0" class="empty-state">
            <mat-icon class="empty-icon">search_off</mat-icon>
            <div class="empty-title">{{ 'general.noResults' | transloco }}</div>
            <div class="empty-subtitle">{{ 'general.tryDifferentSearch' | transloco }}</div>
        </div>
    </div>
</div>

<!-- Video Preview Dialog -->
<ng-template #videoPreviewDialog let-modal>
    <div class="video-preview-dialog">
        <!-- Modern Header with Gradient -->
        <div class="video-preview-header" mat-dialog-title>
            <div class="header-content">
                <div class="header-left">
                    <div class="icon-wrapper">
                        <mat-icon class="header-icon">play_circle</mat-icon>
                    </div>
                    <div class="header-text">
                        <h2 class="header-title">{{ 'ai.video' | transloco }} {{ 'general.preview' | transloco }}</h2>
                        <p class="header-subtitle" *ngIf="previewingVideo">{{ 'general.by' | transloco }} {{ previewingVideo?.user?.name }}</p>
                    </div>
                </div>
                <button mat-icon-button class="close-button" mat-dialog-close>
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <!-- Video Player Container -->
        <div mat-dialog-content class="video-preview-content">
            <div class="video-container">
                <video *ngIf="previewingVideo"
                       controls
                       autoplay
                       playsinline
                       [src]="getVideoStreamUrl(previewingVideo)"
                       class="preview-video">
                    {{ 'general.videoNotSupported' | transloco }}
                </video>
            </div>

            <!-- Video Metadata - Compact Inline Layout -->
            <div class="video-metadata">
                <div class="metadata-item">
                    <mat-icon>person</mat-icon>
                    <span class="metadata-text">{{ previewingVideo?.user?.name }}</span>
                </div>
                <div class="metadata-divider"></div>
                <div class="metadata-item">
                    <mat-icon>aspect_ratio</mat-icon>
                    <span class="metadata-text">{{ previewingVideo?.width }} × {{ previewingVideo?.height }}</span>
                </div>
                <div class="metadata-divider"></div>
                <div class="metadata-item">
                    <mat-icon>schedule</mat-icon>
                    <span class="metadata-text">{{ previewingVideo?.duration }}s</span>
                </div>
            </div>
        </div>

        <!-- Modern Action Buttons -->
        <div mat-dialog-actions class="video-preview-actions">
            <button mat-stroked-button class="action-button cancel-button" mat-dialog-close>
                <mat-icon>close</mat-icon>
                <span>{{ 'general.close' | transloco }}</span>
            </button>
            <button mat-raised-button
                    color="accent"
                    class="action-button download-button"
                    [disabled]="previewingVideo?.downloading"
                    (click)="downloadVideo(previewingVideo)">
                <mat-icon *ngIf="!previewingVideo?.downloading">download</mat-icon>
                <app-loading *ngIf="previewingVideo?.downloading" [size]="'18px'"></app-loading>
                <span>{{ 'general.downloadToResources' | transloco }}</span>
            </button>
        </div>
    </div>
</ng-template>
